module.exports = __webpack_public_path__ + "img/logo-viet-nam.463ff7e9.png";